(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        if (document.querySelector('.eventlist') !== null) {
            const formElement = document.querySelector('.eventlist .event-list-filter');
            let noEventElement = document.querySelector('.eventlist .no-events');
            const resetFilterElement = document.querySelector('.eventlist .reset-all-filter');

            const topicSelectId = 'event-filter-topics';
            const targetGroupSelectId = 'event-filter-target-groups';
            const citySelectId = 'event-filter-cities';
            const keywordsId = 'event-filter-text';
            const stepSelectId = 'event-filter-steps';
            const topics = document.querySelectorAll('#' + topicSelectId);
            const groups = document.querySelectorAll('#' + targetGroupSelectId);
            const cities = document.querySelectorAll('#' + citySelectId);

            const columns = parseInt(document.querySelector('.eventlist').getAttribute('data-columns'));
            let offset = parseInt(document.querySelector('.eventlist').getAttribute('data-offset'));
            const limit = parseInt(document.querySelector('.eventlist').getAttribute('data-limit'));
            const endlessScroll = parseInt(document.querySelector('.eventlist').getAttribute('data-endlessscroll')) === 1;
            const showOnlyFutureEvents = document.querySelector('.eventlist').getAttribute('data-showonlyfutureevents');
            let preSelectedTopics = JSON.parse(document.querySelector('.eventlist').getAttribute('data-selectedtopics'));
            let preSelectedTargetGroups = JSON.parse(document.querySelector('.eventlist').getAttribute('data-selectedtargetgroups'));
            let preSelectedCities = JSON.parse(document.querySelector('.eventlist').getAttribute('data-selectedcities'));
            let selectedSteps = JSON.parse(document.querySelector('.eventlist').getAttribute('data-selectedsteps'));
            let keywords = document.querySelector('.eventlist').getAttribute('data-searchtext');
            const fromdate = document.querySelector('.eventlist').getAttribute('data-fromdate');
            const todate = document.querySelector('.eventlist').getAttribute('data-todate');

            let loading = false;
            let resetOldEvents = false;

            /**
             * Fill in the dropdowns
             */
            const params = new URLSearchParams(window.location.search);

            function getParameterValues(paramName) {
                return params.getAll(`filter[${paramName}][]`).map(decodeURIComponent);
            }

            selectedTopics = getParameterValues('topic').length > 0 ? getParameterValues('topic') : preSelectedTopics;
            if (topics.length) {
                fillDropdowns(topics, selectedTopics);
            }

            selectedTargetGroups = getParameterValues('targetGroup').length > 0 ? getParameterValues('targetGroup') : preSelectedTargetGroups;
            if (groups.length) {
                fillDropdowns(groups, selectedTargetGroups);
            }

            selectedCities = getParameterValues('city').length > 0 ? getParameterValues('city') : preSelectedCities;
            if (cities.length) {
                fillDropdowns(cities, selectedCities);
            }

            /**
             * Load events
             */
            const loadEvents = () => {
                if (loading) {
                    return;
                }
                loading = true;

                selectedSteps = document.getElementById(stepSelectId) ? document.getElementById(stepSelectId).value : selectedSteps;
                keywords = document.getElementById(keywordsId) ? document.getElementById(keywordsId).value : keywords;

                if (noEventElement !== null) {
                    noEventElement.classList.add('d-none');
                }

                Array.prototype.forEach.call(topicSelectId, (el) => {
                    if (el.selected) {
                        selectedTopics.push(el.value);
                    }
                });

                Array.prototype.forEach.call(targetGroupSelectId, (el) => {
                    if (el.selected) {
                        selectedTargetGroups.push(el.value);
                    }
                });

                Array.prototype.forEach.call(citySelectId, (el) => {
                    if (el.selected) {
                        selectedCities.push(el.value);
                    }
                });

                let url = window._AVENCY_BASE_actions.eventList;
                url += (keywords !== undefined && keywords !== '') ? '&keywords=' + keywords : '';
                url += selectedSteps !== undefined ? '&searchSteps=' + selectedSteps : '';
                url += selectedTopics !== undefined ? '&topic=' + JSON.stringify(selectedTopics.filter(x => !!x)) : '';
                url += selectedTargetGroups !== undefined ? '&targetGroup=' + JSON.stringify(selectedTargetGroups.filter(x => !!x)) : '';
                url += selectedCities !== undefined ? '&city=' + JSON.stringify(selectedCities.filter(x => !!x)) : '';
                url += '&fromDate=' + encodeURIComponent(fromdate);
                url += '&toDate=' + encodeURIComponent(todate);
                url += '&columns=' + columns;
                url += '&offset=' + offset;
                url += '&limit=' + limit;
                url += '&showOnlyFutureEvents=' + showOnlyFutureEvents;

                const request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.onload = function () {
                    if (this.status >= 200 && this.status < 400 && this.response !== '') {
                        if (endlessScroll && offset > 0) {
                            document.querySelector('.eventlist .eventlist-listing').innerHTML += this.response;
                        } else {
                            document.querySelector('.eventlist .eventlist-listing').innerHTML = this.response;
                        }
                        if (formElement) {
                            formElement.setAttribute('data-filtered', true);
                        }
                        loading = false;
                        offset += limit;
                    } else {
                        if (!endlessScroll || offset === 0) {
                            if (noEventElement !== null) {
                                noEventElement.classList.remove('d-none');
                            }
                            document.querySelector('.eventlist .eventlist-listing').innerHTML = '';
                        }
                    }
                };
                request.send();
            }

            // Reset all filter
            if (resetFilterElement) {
                resetFilterElement.addEventListener('click', (e) => {
                    window.location = window.location.href.split("?")[0];
                });
            }

            // Load events on submit
            if (formElement) {
                formElement.addEventListener('submit', (e) => {
                    resetOldEvents = true;
                    offset = 0;
                    loading = false;
                    loadEvents();
                });
            }

            // Load first batch of events
            loadEvents();

            /**
             * Check if events bottom is in viewport
             *
             * @returns {boolean}
             */
            const isInViewport = () => {
                const endlessScrollElement = document.querySelector('.eventlist .eventlist-endlessscroll');
                const bounding = endlessScrollElement.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            if (endlessScroll) {
                window.addEventListener('scroll', () => {
                    if (isInViewport()) {
                        loadEvents();
                    }
                }, {passive: true});
            }

            // remove selected options by click on default value
            addChangeListener(topics[0], topicSelectId);
            addChangeListener(groups[0], targetGroupSelectId);
            addChangeListener(cities[0], citySelectId);

            // Add apply-button into dropdown
            if (document.querySelector('.eventlist') !== null) {
                // Add apply-button into dropdown
                $('.dropdown-toggle').on('show.bs.dropdown', function (e) {
                    const applyButtonExists = $(this).parent('.filter-dropdown.show .inner.show .apply-button-container').length > 0;
                    const applyButtonText = window._AVENCY_BASE_translations.events.applyButton;

                    if (!applyButtonExists) {
                        const applyButton = '<div class="apply-button-container"><div class="apply-button d-grid gap-2"><button type="button" class="btn btn-primary">' + applyButtonText + '</button></div></div>';
                        $(this).parent('.filter-dropdown').find('div.inner.show').append(applyButton);
                    }
                });
            }
        }

        function fillDropdowns(dropdown, selectedValues) {
            Array.from(dropdown[0].children).forEach(item => {
                if (selectedValues.includes(item.value)) {
                    item.selected = true;
                }
            });
        }

        /**
         * Remove selected options by click on default value
         *
         * @param element
         * @param selectId
         */
        function addChangeListener(element, selectId) {
            if (element === undefined) {
                return;
            }

            element.addEventListener('change', (e) => {
                if (e.target.value === '') {
                    $('#' + selectId).selectpicker('deselectAll');
                }
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
